import { Observable } from 'rxjs/Observable';
import history from '../routers/history';
import {isMobileDevice} from '../utils/generalUtils';
import getUserEvents from '../actions/events/getUserEventsAction';
import getUserTemplatesAction from '../actions/templates/getUserTemplatesAction';
import getDefaultTemplatesAction from '../actions/templates/getDefaultTemplatesAction';
import getTemplateActivityTypesAction from '../actions/templates/getTemplateActivityTypesAction';
import getDefaultRecommendationCategories from '../actions/recommendations/getDefaultRecommendationCategoriesAction';

export function initAfterLogin(action$, store) {
    return action$.filter(
        action => action.type === 'LOGIN_FULFILLED' || action.type === 'RESTORE_SESSION_FULFILLED' || action.type === 'REGISTER_FULFILLED')
        .mergeMap((action) => {
            if (action.type === 'REGISTER_FULFILLED' && isMobileDevice()) {
                return Observable.merge(
                    Observable.of(() => history.replace('/welcome'))
                );
            } else {
                return Observable.merge(
                    Observable.of(getUserEvents(store.getState().user.data.objectId)),
                    Observable.of(() => history.replace('/')),
                    Observable.of(getUserTemplatesAction(store.getState().user.data.objectId)),
                    Observable.of(getDefaultTemplatesAction(store.getState().user.data.region)),
                    Observable.of(getTemplateActivityTypesAction(store.getState().user.data.region)),
                    Observable.of(getDefaultRecommendationCategories())
                );
            }
        });
}

/*export function initAfterRestore(action$, store) {
 return action$.filter(
 action => action.type === 'RESTORE_SESSION_FULFILLED')
 .mapTo(() => Observable.of(getUserEvents(store.getState().user.data.objectId)));
 }*/



// WEBPACK FOOTER //
// ./src/epics/loginEpic.js